import { cn } from "cn";
import {
  BwClipboardLine,
  BwPenRulerLine,
  BwShieldLine,
} from "@/components/ui/icons";
import { OrderType } from "@/types/openapi-enum";

export type OrderTypeIconType = OrderType;

export function OrderTypeIcon({
  type,
  className,
}: {
  type: OrderTypeIconType;
  className?: string;
}) {
  switch (type) {
    case OrderType.Service:
      return <BwPenRulerLine className={cn("size-5 shrink-0", className)} />;
    case OrderType.Project:
      return <BwClipboardLine className={cn("size-5 shrink-0", className)} />;
    case OrderType.Warranty:
      return <BwShieldLine className={cn("size-5 shrink-0", className)} />;
    default:
      return null;
  }
}
